import { NavLink } from 'react-router';

/**
 * Sub-nav inside admin pages. Mirrors the main NavTab pill style at
 * smaller scale. Lives in its own component so each admin page just
 * drops <AdminSubNav /> below the page title.
 *
 * Currently two tools — Clients (org roster) and Bot research
 * (forensic per-link view). If we add more (incident log, etc.) just
 * append a tab here.
 */
export function AdminSubNav() {
  return (
    <nav className="-mt-2 mb-6 flex flex-wrap items-center gap-1 text-xs">
      <SubTab to="/app/admin/clients">Clients</SubTab>
      <SubTab to="/app/admin/bot-research">Bot research</SubTab>
      <SubTab to="/app/admin/platform-pixel">Platform pixel</SubTab>
    </nav>
  );
}

function SubTab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `rounded-full px-3 py-1 font-medium transition ${
          isActive
            ? 'bg-[var(--color-primary)] text-[var(--color-primary-foreground)]'
            : 'text-[var(--color-on-surface-variant)] hover:bg-[var(--surface-glass)] hover:text-[var(--color-foreground)]'
        }`
      }
    >
      {children}
    </NavLink>
  );
}
